if (!customElements.get('combined-swatches')) {
  customElements.define(
    'combined-swatches',
    class CombinedSwatches extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onSwatchClick.bind(this));
      }

      getVariants() {
        this.variants = this.variants || JSON.parse(this.dataset.variants || '[]');
        return this.variants;
      }

      // Carries the selected size over to the other product. When that size is
      // sold out in the colour, the link's own href (first available) applies.
      onSwatchClick(event) {
        const swatch = event.target.closest('[data-color]');
        if (!swatch) return;

        const picker = this.closest('variant-selects');
        const size = picker?.querySelector('input[name="Size"]:checked')?.value;
        if (!size) return;

        const variant = this.getVariants().find(
          (item) => item.available && item.color === swatch.dataset.color && item.size === size
        );
        if (!variant) return;

        event.preventDefault();
        window.location.href = `${this.dataset.url}?variant=${variant.id}`;
      }
    }
  );
}
